import axiosInstance from "../../config/Axios";

export const getDukaStocks = async ({ page = 1, limit = 10, duka, product, ...filters } = {}) => {
  try {
    const offset = (page - 1) * limit;
    const response = await axiosInstance({
      method: "get",
      url: "/api/duka/duka-stocks/",
      params: {
        limit,
        offset,
        ...(duka && { duka }),
        ...(product && { product }),
        ...filters,
      },
    });
    return {
      data: response.data.results,
      total: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
    };
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getDukaStockById = async (id) => {
  try {
    return await axiosInstance({
      method: "get",
      url: `/api/duka/duka-stocks/${id}/`,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const createDukaStock = async (stockData) => {
  try {
    return await axiosInstance({
      method: "post",
      url: "/api/duka/duka-stocks/",
      data: stockData,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateDukaStock = async (id, stockData) => {
  try {
    return await axiosInstance({
      method: "put",
      url: `/api/duka/duka-stocks/${id}/`,
      data: stockData,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteDukaStock = async (id) => {
  if (!id) {
    return Promise.reject(new Error("Stock ID is required"));
  }
  try {
    const response = await axiosInstance({
      method: "delete",
      url: `/api/duka/duka-stocks/${id}/`,
    });
    return response;
  } catch (error) {
    console.error("Delete API Error:", error?.response?.data || error.message);
    return Promise.reject(error);
  }
};

// Custom endpoint to update Duka Stock on order delivery (if needed)
export const updateDukaStockOnDelivery = async (data) => {
  try {
    return await axiosInstance({
      method: "post",
      url: `/api/duka/duka-stocks/update/`,
      data,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const bulkUploadStock = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    return await axiosInstance({
      method: "post",
      url: "/api/duka/stock/bulk-upload/",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export default {
  getDukaStocks,
  getDukaStockById,
  createDukaStock,
  updateDukaStock,
  deleteDukaStock,
  updateDukaStockOnDelivery,
};
